import React from 'react'

// Circular checkboxes
export const CheckboxUnchecked = () => (
  <svg
    width="22px"
    height="22px"
    viewBox="0 0 22 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className="block"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect
        stroke="#666666"
        strokeWidth="2"
        x="1"
        y="1"
        width="20"
        height="20"
        rx="10"
      />
    </g>
  </svg>
)

export const CheckboxChecked = ({ color = 'text-secondary' }) => (
  <svg
    width="22px"
    height="22px"
    viewBox="0 0 22 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={`${color} overflow-visible block`}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <rect fill="currentColor" x="0" y="0" width="22" height="22" rx="11" />
        <path
          d="M9.27280898,12.6058707 L15.5857864,6.29289322 C15.7810486,6.09763107 16.0976311,6.09763107 16.2928932,6.29289322 L17.7071068,7.70710678 C17.9023689,7.90236893 17.9023689,8.21895142 17.7071068,8.41421356 L9.3939256,16.7273947 C9.20672745,16.9145929 8.90605805,16.9234285 8.70819029,16.747546 L3.8771589,12.4532959 C3.67076752,12.2698369 3.65217715,11.9538007 3.83563616,11.7474093 L5.16436384,10.2525907 C5.34782285,10.0461993 5.66385903,10.0276089 5.87025042,10.2110679 L8.58707367,12.6260219 C8.78494143,12.8019044 9.08561084,12.7930688 9.27280898,12.6058707 Z"
          fill="#FFFFFF"
          fillRule="nonzero"
        />
      </g>
    </g>
  </svg>
)

// Square checkboxes
export const CheckboxSquareUnchecked = () => (
  <svg
    width="22px"
    height="22px"
    viewBox="0 0 22 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect
        stroke="#666666"
        strokeWidth="2"
        x="1"
        y="1"
        width="20"
        height="20"
        rx="3"
      />
    </g>
  </svg>
)

export const CheckboxSquareChecked = ({ color = 'text-secondary' }) => (
  <svg
    width="22px"
    height="22px"
    viewBox="0 0 22 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={color}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <rect fill="currentColor" x="0" y="0" width="22" height="22" rx="3" />
        <path
          d="M9.27280898,12.6058707 L15.5857864,6.29289322 C15.7810486,6.09763107 16.0976311,6.09763107 16.2928932,6.29289322 L17.7071068,7.70710678 C17.9023689,7.90236893 17.9023689,8.21895142 17.7071068,8.41421356 L9.3939256,16.7273947 C9.20672745,16.9145929 8.90605805,16.9234285 8.70819029,16.747546 L3.8771589,12.4532959 C3.67076752,12.2698369 3.65217715,11.9538007 3.83563616,11.7474093 L5.16436384,10.2525907 C5.34782285,10.0461993 5.66385903,10.0276089 5.87025042,10.2110679 L8.58707367,12.6260219 C8.78494143,12.8019044 9.08561084,12.7930688 9.27280898,12.6058707 Z"
          id="Path-2-Copy"
          fill="#FFFFFF"
          fillRule="nonzero"
        />
      </g>
    </g>
  </svg>
)

export const CheckboxSquareIndeterminate = ({ color = 'text-secondary' }) => (
  <svg
    width="22px"
    height="22px"
    viewBox="3 3 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={color}
  >
    <path
      fill="currentColor"
      d="M17,13H7V11H17M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z"
    />
  </svg>
)
